<template>
  <div>
    <h2>Applications</h2>
    <v-list-item
      v-for="application in applications"
      :key="application.id"
      @click="() => handleSelect(application)"
    >
      <ApplicationListItem :application="application" />
    </v-list-item>
  </div>
</template>

<script>
import ApplicationListItem from "@/views/applications/components/ApplicationListItem";

export default {
  name: "WorkerApplications",
  components: {
    ApplicationListItem
  },
  props: {
    userData: {
      type: Object,
      required: true
    },
    navigateToBookingCandidates: Boolean
  },
  computed: {
    applications() {
      return this.userData.applications;
    }
  },
  methods: {
    handleSelect(application) {
      if (this.navigateToBookingCandidates) {
        this.$router.push(
          `/jobs/${application.booking.id}/candidates?applicationId=${application.id}`
        );
      } else {
        this.$router.push({
          name: "applicationRole",
          params: { id: application.id }
        });
      }
    }
  }
};
</script>
